import React, { useState, useEffect  } from "react";
import { useNavigate } from "react-router-dom";
import HeaderPage from "../HeaderFooter/header";
import FooterPage from "../HeaderFooter/footer";
import { FaUserPlus } from "react-icons/fa";
import { FaEnvelope } from "react-icons/fa";
import API_BASE_URL from "../../../apiconfig";
import { useLocation } from "react-router-dom";

function Login() {
	
	const navigate = useNavigate();
	const [captcha, setCaptcha] = useState("");
	const [userCaptcha, setUserCaptcha] = useState("");
	const [alertData, setAlertData] = useState(null);
	const [captchaVerified, setCaptchaVerified] = useState(false);
	const [showPassword, setShowPassword] = useState(false);
	const location = useLocation();
	
	useEffect(() => {
	  if (location.state?.message) {
	    setAlertData({
	      message: location.state.message,
	      id: Date.now()
	    });
	  }
	}, [location.state]);
	
	
	const generateCaptcha = () => {
		const chars = "ABCDEFGHJKLMNPQRSTUVWXYZ23456789";
		let result = "";
		for (let i = 0; i < 5; i++) {
			result += chars.charAt(Math.floor(Math.random() * chars.length));
		}
		setCaptcha(result);
	};

	useEffect(() => {
		generateCaptcha();
	}, []);

	useEffect(() => {
		if (alertData) {
			const timer = setTimeout(() => setAlertData(null), 5000);
			return () => clearTimeout(timer);
		}
	}, [alertData]);
	
	
	const [username, setUsername] = useState("");
	const [password, setPassword] = useState("");
	const validateUsername = () => {
		const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
		const mobileRegex = /^\d{10}$/;

		if (!username || username.trim() === "") {
			setAlertData({
				message: "Please enter Email or Mobile ❗",
				id: Date.now()
			});
			return false;
		}

		if (!emailRegex.test(username) && !mobileRegex.test(username)) {
			setAlertData({
				message: "Enter valid Email or 10-digit Mobile ❗",
				id: Date.now()
			});
			return false;
		}

		return true;
	};
	
	const validatePassword = () => {
		const regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&]).{8,}$/;

		if (!password) {
			setAlertData({
				message: "Please enter password ❗",
				id: Date.now()
			});
			return false;
		}

		if (!regex.test(password)) {
			setAlertData({
				message: "Password must be strong ❗",
				id: Date.now()
			});
			return false;
		}

		return true;
	};
	
	const handleLogin = async () => {

		// 🔥 validations
		if (!validateUsername()) return;
		if (!validatePassword()) return;

		if (!captchaVerified) {
			setAlertData({
				message: "Please verify CAPTCHA ❗",
				id: Date.now()
			});
			return;
		}

		try {
		    const res = await fetch(`${API_BASE_URL}/API/Student/LOGIN`, {
		        method: "POST",
		        headers: {
		            "Content-Type": "application/json"
		        },
		        body: JSON.stringify({
		            username: username,
		            password: password
		        })
		    });

		    const data = await res.json();

		    if (res.ok) {

		        // ✅ SAVE TOKEN
		        //localStorage.setItem("token", data.token);
				sessionStorage.setItem("token", data.token);

		        setAlertData({
		            message: data.message || "Login Successful ✅",
		            type: "success",
		            id: Date.now()
		        });

				setTimeout(() => {
				    navigate("/Dashboard", { replace: true });
				}, 1200);

		    } else {

		        setAlertData({
		            message: data.message || "Invalid credentials ❌",
		            type: "error",
		            id: Date.now()
		        });
		    }

		} catch (err) {
		    setAlertData({
		        message: "Server error ❌",
		        type: "error",
		        id: Date.now()
		    });
		}
	};



	
	





	return (
		<>
			<style>{`
		.main-section {
		  display: flex;
		  justify-content: center;
		  padding: 30px 10px;
		  font-family: 'Poppins', sans-serif;

		  animation: fadeSlideUp 0.6s ease-out;
		}
		
		@keyframes fadeSlideUp {
		  from {
		    opacity: 0;
		    transform: translateY(30px);
		  }
		  to {
		    opacity: 1;
		    transform: translateY(0);
		  }
		}

        .card {
          width: 100%;
          max-width: 450px; /* 🔥 reduced width */
          background: rgba(255,255,255,0.95);
          padding: 25px 22px;
          border-radius: 14px;
          box-shadow: 0 6px 20px rgba(0,0,0,0.08);
          border: 1px solid rgba(0,0,0,0.05);
		  margin-top: -20px; /* 🔥 move upward */
        }

		.title {
			text-align: center;
			font-size: 18px;
			font-weight: 700;
			margin-bottom: 18px;

			/* 🔥 Gradient text */
			background: linear-gradient(90deg, #4a54d1, #7b83ff, #9fa8ff);
			-webkit-background-clip: text;
			-webkit-text-fill-color: transparent;

			/* 🔥 Stylish font */
			font-family: 'Poppins', 'Segoe UI', sans-serif;
			letter-spacing: 1px;

			/* 🔥 subtle glow */
			text-shadow: 0 2px 6px rgba(74, 84, 209, 0.2);
		}
		.title-icon {
			margin-right: 8px;
			vertical-align: middle;
			color: #4a54d1;
		}

        select {
          width: 100%;
          padding: 10px;
          border-radius: 8px;
          border: 1px solid #ccc;
          margin-bottom: 12px;
          font-size: 13px;
        }

        .row {
          display: flex;
          gap: 8px;
          margin-bottom: 12px;
          align-items: center;
        }
		
		

        input {
          flex: 1;
          padding: 9px;
          border-radius: 8px;
          border: 1px solid #ccc;
          font-size: 13px;
          transition: 0.2s;
        }

        input:focus, select:focus {
          border-color: #6a5cff;
          box-shadow: 0 0 0 2px rgba(106,92,255,0.15);
          outline: none;
        }

        .btn-small {
          padding: 7px 10px;
          border: none;
          border-radius: 8px;
          font-size: 11px;
          cursor: pointer;
          font-weight: 600;
          transition: 0.2s;
        }

        .send-btn {
          background: linear-gradient(135deg, #6a5cff, #8f6bff);
          color: white;
        }

        .verify-btn {
          background: #28a745;
          color: white;
        }
		
		.verify-btn-captcha {
			margin-left: 10px;
		        background: #28a745;
		        color: white;
		      }

        .btn-small:hover {
          transform: translateY(-1px);
          box-shadow: 0 3px 8px rgba(0,0,0,0.15);
        }

        .status {
          color: #28a745;
          font-size: 14px;
          font-weight: bold;
        }

        .note {
          font-size: 11px;
          color: #888;
          margin-top: -6px;
          margin-bottom: 10px;
          padding-left: 3px;
        }

        .password-row input {
          flex: 1;
        }

        .register-btn {
          width: 100%;
          margin-top: 12px;
          padding: 11px;
          border-radius: 25px;
          border: none;
          background: linear-gradient(135deg, #6a5cff, #8f6bff);
          color: white;
          font-weight: 600;
          cursor: pointer;
          transition: 0.3s;
        }

        .register-btn:hover {
          transform: translateY(-2px);
          box-shadow: 0 6px 15px rgba(0,0,0,0.2);
        }

        .register-btn:disabled {
          background: #ccc;
          cursor: not-allowed;
          box-shadow: none;
        }

		.floating-group {
		  position: relative;
		  flex: 1;
		}

		.floating-group input {
		  width: 100%;
		  padding: 9px 9px 9px 30px; /* space for icon */
		  border-radius: 8px;
		  border: 1px solid #ccc;
		  font-size: 13px;
		  background: transparent;
		}

		.floating-group label {
		  position: absolute;
		  left: 30px;
		  top: 50%;
		  transform: translateY(-50%);
		  background: white;
		  padding: 0 4px;
		  color: #888;
		  font-size: 13px;
		  pointer-events: none;
		  transition: 0.2s ease;
		}

		/* FLOAT ONLY ON FOCUS OR INPUT */
		.floating-group input:focus + label,
		.floating-group input:not(:placeholder-shown) + label {
		  top: -6px;
		  font-size: 10px;
		  color: #6a5cff;
		}

		/* ICON */
		.floating-group span {
		  position: absolute;
		  left: 8px;
		  top: 50%;
		  transform: translateY(-50%);
		  font-size: 13px;
		}
		
		.back-wrapper {
		  display: flex;
		  justify-content: flex-end;
		  margin-top: 8px;
		  padding-right: 20px; /* 🔥 pushes button slightly left */
		}

		.back-btn {
			  padding: 6px 14px;
			  font-size: 12px;
			  border-radius: 18px;
			  border: 1px solid #c5c9ff;   /* 🔥 light border */
			  background: #f4f6ff;         /* 🔥 light bg */
			  color: #4a54d1;              /* 🔥 soft text color */
			  font-weight: 500;
			  cursor: pointer;
			  transition: all 0.25s ease;
			}

		.back-btn:hover {
		  background: #6a5cff;
		  color: white;
		  border-color: #6a5cff;
		  box-shadow: 0 3px 8px rgba(0,0,0,0.12);
		}
		
		.signin-text {
		  text-align: center;
		  font-size: 12px;
		  margin-top: 10px;
		  color: #666;
		}

		.signin-link {
		  margin-left: 5px;
		  color: #6a5cff;
		  font-weight: 600;
		  cursor: pointer;
		  transition: 0.2s;
		}

		.signin-link:hover {
		  text-decoration: underline;
		  color: #4a54d1;
		}
		
		.captcha-box {
			margin-top: 12px;
			text-align: left;
		}

		.captcha-row {
			display: flex;
			align-items: center;
			gap: 10px;
			margin-bottom: 8px;
		}

		.captcha-text {
			font-weight: bold;
			letter-spacing: 4px;
			background: linear-gradient(135deg, #e0e4ff, #f1f3ff);
			padding: 6px 14px;
			border-radius: 6px;

			/* 🔥 Make it stylish */
			font-family: 'Courier New', monospace;
			transform: skew(-8deg);
			display: inline-block;

			/* 🔥 Slight blur (not too much) */
			filter: blur(0.8px);

			/* 🔥 Add shadow for distortion */
			text-shadow: 1px 1px 2px rgba(0,0,0,0.3);

			/* 🔥 Random rotation feel */
			user-select: none;
		}
		.captcha-text::after {
			content: "";
			position: absolute;
			left: 5px;
			right: 5px;
			top: 50%;
			height: 2px;
			background: rgba(0,0,0,0.3);
			transform: rotate(-10deg);
		}

		.refresh-btn {
			border: none;
			background: #eee;
			padding: 5px 10px;
			cursor: pointer;
			border-radius: 5px;
		}
		.captcha-full-row {
			display: flex;
			align-items: center;
			gap: 10px;
			flex-wrap: wrap; /* prevents breaking on small screens */
		}

		.captcha-text {
			font-weight: bold;
			letter-spacing: 3px;
			background: #f1f3ff;
			padding: 6px 12px;
			border-radius: 6px;
		}

		.captcha-full-row input {
			width: 160px;  /* control size */
		}
		.custom-alert {
			position: fixed;
			top: 30%;
			left: 50%;
			transform: translateX(-50%);
			display: flex;
			align-items: center;
			gap: 10px;
			min-width: 260px;
			max-width: 320px;
			padding: 12px 16px;
			border-radius: 12px;
			backdrop-filter: blur(10px);
			font-size: 13px;
			font-weight: 500;
			z-index: 9999;
			animation: slideDown 0.4s ease, fadeOut 0.4s ease 4.6s forwards;
		}

		/* ❌ ERROR (RED) */
		.custom-alert.error {
			background: rgba(255, 77, 79, 0.1);
			border: 1px solid rgba(255, 77, 79, 0.3);
			box-shadow: 0 8px 25px rgba(255, 77, 79, 0.2);
			color: #b30000;
		}

		/* ✅ SUCCESS (GREEN) */
		.custom-alert.success {
			background: rgba(40, 167, 69, 0.1);
			border: 1px solid rgba(40, 167, 69, 0.3);
			box-shadow: 0 8px 25px rgba(40, 167, 69, 0.2);
			color: #1e7e34;
		}
		.alert-icon {
			font-size: 16px;
		}

		@keyframes slideDown {
			from {
				opacity: 0;
				transform: translate(-50%, -60px) scale(0.95);
			}
			to {
				opacity: 1;
				transform: translate(-50%, 0) scale(1);
			}
		}

		@keyframes fadeOut {
			to {
				opacity: 0;
				transform: translate(-50%, -40px) scale(0.95);
			}
		}
		@keyframes fadeIn {
			from {
				opacity: 0;
				transform: translateY(-5px);
			}
			to {
				opacity: 1;
				transform: translateY(0);
			}
		}
		
		.verify-btn-captcha.verified {
			background: #28a745;
			opacity: 0.6;
			filter: blur(0.4px);

			/* 🔥 important */
			pointer-events: none;   /* no click at all */
			cursor: not-allowed;    /* 🚫 icon */
		}
		
		.disabled-input {
			background: #f5f5f5;
			color: #888;
			cursor: not-allowed;
		}

		.disabled-btn {
			opacity: 0.6;
			cursor: not-allowed;
			filter: grayscale(30%);
		}
		
		.toggle-eye {
			cursor: pointer;
			user-select: none;     /* 🔥 prevent text cursor */
			margin: 0 5px;
			font-size: 14px;
			display: flex;
			align-items: center;
		}
		
		.captcha-full-row {
		  display: flex;
		  align-items: center;
		  gap: 10px;
		  flex-wrap: wrap;

		  /* 🔥 ADD THIS */
		  border: 1px solid rgba(106,92,255,0.2);
		  box-shadow: 0 3px 10px rgba(106,92,255,0.08);
		  padding: 10px;
		  border-radius: 10px;
		  background: #fafbff; /* light highlight */
		}
		
		
		
        @media (max-width: 600px) {
          .row {
            flex-wrap: wrap;
          }
        }
      `}</style>

			<HeaderPage />

			<div className="back-wrapper">
				<button
					className="back-btn"
					onClick={() => window.location.href = "/ASTU_JMEE_JLEE"}
				>
					← Back to Home
				</button>
			</div>

			<div className="main-section">
				<div className="card">
					<div className="title">
						<FaUserPlus className="title-icon" /> Login
					</div>

					{/* USERNAME */}
					<div className="row">
						<input
							type="text"
							placeholder="📧 Email or Mobile"
							value={username}
							onChange={(e) => setUsername(e.target.value)}
						/>
					</div>

					{/* PASSWORD */}
					<div className="row">
						<input
							type={showPassword ? "text" : "password"}
							placeholder="🔒 Password"
							value={password}
							onChange={(e) => setPassword(e.target.value)}
						/>

						<span
							className="toggle-eye"
							onClick={() => setShowPassword(!showPassword)}
						>
							{showPassword ? "🙈" : "👁️"}
						</span>
					</div>

					{/* FORGOT PASSWORD */}
					<div style={{ textAlign: "right", marginTop: "4px" }}>
					<span
					    className="signin-link"
					    style={{ fontSize: "11px" }}
					    onClick={() => navigate("/Forgot_Password")}
					>
					    Forgot Password?
					</span>
					</div>

					{/* CAPTCHA */}
					<div className="captcha-box">
						<div className="captcha-full-row">

							<span className="captcha-text">{captcha}</span>

							<button
								onClick={generateCaptcha}
								className="refresh-btn"
								disabled={captchaVerified}   // ✅ disable after verify
							>
								↻
							</button>

							<input
								type="text"
								placeholder="🔐 Enter CAPTCHA"
								value={userCaptcha}
								onChange={(e) => setUserCaptcha(e.target.value)}
								disabled={captchaVerified}   // ✅ disable input
								className={captchaVerified ? "disabled-input" : ""}
							/>

							<button
								className={`btn-small verify-btn-captcha ${captchaVerified ? "verified" : ""}`}
								disabled={captchaVerified}   // ✅ disable button
								onClick={() => {
									if (captchaVerified) return; // extra safety

									if (userCaptcha === captcha) {
										setCaptchaVerified(true);
									} else {
										setCaptchaVerified(false);
										setAlertData({
											message: "Invalid CAPTCHA ❌",
											id: Date.now()
										});
										generateCaptcha();
									}
								}}
							>
								{captchaVerified ? "Verified" : "Verify"}  {/* 🔥 text change */}
							</button>

							{captchaVerified && <span className="status">✔</span>}

						</div>
					</div>

					{/* LOGIN BUTTON */}
					<button
						className="register-btn"
						onClick={handleLogin}
						disabled={!captchaVerified}
					>
						Login
					</button>

					{/* REGISTER LINK */}
					{/*<div className="signin-text">
					    New user?
					    <span
					        className="signin-link"
					        onClick={() => navigate("/Registration")}
					    >
					        Register
					    </span>
					</div>*/}
					
					<div className="signin-text">
					    New user?
					    <span
					        className="signin-link"
					        onClick={() =>
					            setAlertData({
					                message: "Registration Closed ❌",
					                id: Date.now()
					            })
					        }
					    >
					        Register
					    </span>
					</div>
				</div>
				{alertData && (
					<div className={`custom-alert ${alertData.type === "success" ? "success" : "error"}`} key={alertData.id}>
						<span className="alert-icon">⚠️</span>
						{alertData.message}
					</div>
				)}

			</div>



			<FooterPage />
		</>
	);
}

export default Login;